// src/components/VisionMission.js
import React, { useState, useEffect } from "react";
import "./Footer.css"; // External CSS जोडले
import { Link } from "react-router-dom";

const Footer = () => {
  const [slide, setSlide] = useState(0);
  const [lang, setLang] = useState("en");

  // Load language from localStorage
  useEffect(() => {
    const savedLang = localStorage.getItem("lang");
    if (savedLang && ["en", "hi", "mr"].includes(savedLang)) {
      setLang(savedLang);
    }
  }, []);

  // Save language
  useEffect(() => {
    localStorage.setItem("lang", lang);
  }, [lang]);

  // Auto slide
  useEffect(() => {
    const id = setInterval(() => setSlide((s) => (s + 1) % 3), 5000);
    return () => clearInterval(id);
  }, []);

  // ALL TEXT IN ONE PLACE
  const text = {
    en: {
      aboutCompany: "About Company",
      usefulLinks: "Useful Links",
      othersLinks: "Other Links",
      footerLinks: [
        { name: "Location", path: "/contact-us" },
        { name: "Contact Us", path: "/contact-us" },
        { name: "Gallery", path: "/gallery" },
        { name: "Services", path: "/services-iso-standards" },
      ],
      copyright: `© ${new Date().getFullYear()} Global Certification. All Rights Reserved.`,
    },

    hi: {
      aboutCompany: "कंपनी के बारे में",
      usefulLinks: "उपयोगी लिंक",
      othersLinks: "अन्य लिंक",
      footerLinks: [
        { name: "स्थान", path: "/contact-us" },
        { name: "हमसे संपर्क करें", path: "/contact-us" },
        { name: "गैलरी", path: "/gallery" },
        { name: "सेवाएँ", path: "/services-iso-standards" },
      ],
      copyright: `© ${new Date().getFullYear()} ग्लोबल सर्टिफिकेशन। सभी अधिकार सुरक्षित।`,
    },

    mr: {
      aboutCompany: "कंपनीबद्दल",
      usefulLinks: "उपयोगी लिंक्स",
      othersLinks: "इतर लिंक्स",
      footerLinks: [
        { name: "स्थान", path: "/contact-us" },
        { name: "आमच्याशी संपर्क", path: "/contact-us" },
        { name: "गॅलरी", path: "/gallery" },
        { name: "सेवा", path: "/services-iso-standards" },
      ],
      copyright: `© ${new Date().getFullYear()} ग्लोबल सर्टिफिकेशन। सर्व हक्क राखीव।`,
    },
  };

  // Safe fallback
  const t = text[lang] || text.en;
  return (
    <div className="vision-mission-container">
      {/* FOOTER */}
      <footer className="footer">
        <div className="footer-grid">
          <div className="footer-col">
            <h4>{t.aboutCompany}</h4>
            <p>{t.globalCert}<br />{t.address}</p>
          </div>
          <div className="footer-col">
            <h4>{t.usefulLinks}</h4>
            <Link to="/about-us" className="f-link">About Us</Link>
            <Link to="/about-us" className="f-link">Company Profile</Link>
            <Link to="/vision-mission" className="f-link">Vision Mission</Link>
          </div>
          <div className="footer-col">
            <h4>{t.othersLinks}</h4>
            {t.footerLinks.map((link, i) => (
              <Link key={i} to={link.path} className="f-link">{link.name}</Link>
            ))}
          </div>
        </div>
        <p className="copyright">{t.copyright}</p>
      </footer>
    </div>
  );
};

export default Footer;
